import { returnPageVariableHash } from './lm_title_description_service';

import config from '@/localconfig';
import { parseUrlForGenderWithString } from './maps';
const urlBase = config.BASE_URL;

let hashOfLMMetaData = {};

const getGeneratorInfo = function (url) {
  return fetch(urlBase + '/api/v1/generators/fetch_by_url?url=' + encodeURIComponent(url));
};

function seo(url) {
  hashOfLMMetaData = {};
  hashOfLMMetaData = returnPageVariableHash(url);

  // Retrive PageTitle and MetaDescription of the page. TODO: Rest Hash variables
  getGeneratorInfo(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.generator) {
        hashOfLMMetaData.pageTitle = data.generator.title;
        hashOfLMMetaData.pageMetaDescription = data.generator.description;
        hashOfLMMetaData.pageMetaContent = data.generator.content;
        hashOfLMMetaData.pageCanonicalUrl = data.generator.canonical;
        hashOfLMMetaData.previous = data.generator.previous;
        hashOfLMMetaData.next = data.generator.next;

        document.title = hashOfLMMetaData.pageTitle;
        const canonicalLink = document.querySelector('link[rel=canonical]');
        const titleMetaTag = document.querySelector('meta[name=title]');
        const descriptionMetaTag = document.querySelector('meta[name=description]');

        if (titleMetaTag) {
          titleMetaTag.setAttribute('content', hashOfLMMetaData.pageTitle);
        }
        if (descriptionMetaTag) {
          descriptionMetaTag.setAttribute('content', hashOfLMMetaData.pageMetaDescription);
        }

        if (canonicalLink) {
          // console.log('tree');
          canonicalLink.setAttribute('href', hashOfLMMetaData.pageCanonicalUrl);
          canonicalLink.setAttribute('content', hashOfLMMetaData.pageCanonicalUrl);
        } else {
          // console.log('treesss');
          const newCanonicalLink = document.createElement('link');
          newCanonicalLink.setAttribute('rel', 'canonical');
          newCanonicalLink.setAttribute('href', hashOfLMMetaData.pageCanonicalUrl);
          newCanonicalLink.setAttribute('content', hashOfLMMetaData.pageCanonicalUrl);
          document.head.appendChild(newCanonicalLink);
        }
        const prevLinkQuery = document.querySelector('link[rel=prev]');
        const nextLinkQuery = document.querySelector('link[rel=next]');
        if (prevLinkQuery) {
          prevLinkQuery.setAttribute('href', hashOfLMMetaData.previous);
        }
        if (nextLinkQuery) {
          nextLinkQuery.setAttribute('href', hashOfLMMetaData.previous);
        }
        const propertUrlQuery = document.querySelector('meta[property="og:url"]');
        if (propertUrlQuery) {
          propertUrlQuery.setAttribute('content', hashOfLMMetaData.pageCanonicalUrl);
        }
        const properTitleQuery = document.querySelector('meta[property="og:title"]');
        if (properTitleQuery) {
          properTitleQuery.setAttribute('content', hashOfLMMetaData.pageTitle);
        }
        const properDescriptionQuery = document.querySelector('meta[property="og:description"]');
        if (properDescriptionQuery) {
          properDescriptionQuery.setAttribute('content', hashOfLMMetaData.pageMetaDescription);
        }
      }
    })
    .catch((err) => {
      // throw new Error('Cannot set property of null');
      console.log(err.message);
    });
}

// utils/seo.js

export async function fetchSeoData(url) {
  const response = await fetch(urlBase + '/api/v1/generators/fetch_by_url?url=' + encodeURIComponent(url));
  const data = await response.json();
  return data.generator;
}

function generateAlternativeGenderUrl(hashArray = null) {
  const genderMap = {
    men: 'women',
    women: 'men',
    boys: 'girls',
    girls: 'boys',
  };

  // If hashArray is provided, use it (for server-side rendering)
  if (hashArray && hashArray.length >= 3) {
    // Handle case where hashArray might have empty first element
    // e.g., ['', 'height-charts', 'boys', '16-years-old'] or ['height-charts', 'boys', '16-years-old']
    let genderIndex = 1;
    if (hashArray[0] === '') {
      genderIndex = 2; // Gender is at index 2 if first element is empty
    }
    
    const currentGender = hashArray[genderIndex];
    const alternativeGender = genderMap[currentGender] || 'boys';
    
    // Create the alternative URL using hashArray
    const pathParts = [...hashArray];
    pathParts[genderIndex] = alternativeGender;
    
    // Remove empty first element if present to avoid double slashes
    if (pathParts[0] === '') {
      pathParts.shift();
    }
    
    // Ensure proper URL construction without double slashes
    const adjustedUrlBase = urlBase.endsWith('/') ? urlBase.slice(0, -1) : urlBase;
    return adjustedUrlBase + '/' + pathParts.join('/');
  }

  // Client-side version using window.location
  if (typeof window === 'undefined') return '/'; // SSR safety

  const pathParts = window.location.pathname.split('/').filter(Boolean);

  if (pathParts.length < 3) return '/'; // Not enough parts to modify

  // Replace gender segment with its alternative (gender is at index 1)
  pathParts[1] = genderMap[pathParts[1]] || 'boys';

  return '/' + pathParts.join('/');
}

function addNoFollowAttr(htmlString = '') {
  const allowedDomains = ['https://lifemeasure.com', 'https://lifemeasure-stagging-75c7cd09fba7.herokuapp.com'];

  const isAllowed = (href) => {
    try {
      const url = new URL(href);
      return allowedDomains.some((domain) => url.hostname.includes(domain));
    } catch (error) {
      return false;
    }
  };

  return htmlString.replace(/<a\s+([^>]*href="([^"]+)"[^>]*)>/gi, (match, attributes, href) => {
    if (!isAllowed(href)) {
      if (/rel="nofollow"/i.test(attributes)) {
        return `<a ${attributes}>`;
      } else {
        return `<a ${attributes} rel="nofollow">`;
      }
    }
    return match;
  });
}

const chartsSchemaScript = ({
  chartTitle,
  blurbData,
  pageDataH1Title,
  pageDataH1SubTitle,
  unit,
  chartImage,
  splittedURL,
}) => {
  const getMetaTitle = () => {
    return `${pageDataH1Title}${pageDataH1SubTitle}`;
  };

  const getMetaDescription = () => {
    return `In most cases, ${parseUrlForGenderWithString(splittedURL)} ${chartTitle} measurements for this age group (${
      blurbData.ageDesc
    }) will lie within the range between ${blurbData.percentile_3 || blurbData.percentile_2} and ${
      ' ' + blurbData.percentile_97 || blurbData.percentile_98
    } ${unit}. The average ${chartTitle} measurement for this age group ${parseUrlForGenderWithString(
      splittedURL,
    )} is ${blurbData.percentile_50} ${unit}, according to the CDC`;
  };

  return (
    <script
      type="application/ld+json"
      id="schema-script"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'MediaObject',
          name: getMetaTitle(),
          description: getMetaDescription(),
          contentUrl: chartImage || '',
          encodingFormat: 'image/png',
        }),
      }}
    />
  );
};

export { hashOfLMMetaData, seo, addNoFollowAttr, getGeneratorInfo, generateAlternativeGenderUrl, chartsSchemaScript };
